import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($rootScope, $scope, $http, tracking) {
  $scope.isSending = null;
  $scope.sendResult = null;
  $scope.buttonOptions = {
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'SEND',
    buttonSubmittingText: ' ',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: ' ',
    buttonSuccessClass: 'btn-success',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Error',
    buttonErrorClass: 'btn-danger'
  };

  $scope.resetForm = function() {
    $scope.phone = null;
    $scope.form.$setPristine();
    $scope.submitted = false;
  };

  $scope.sendSMS = function(form) {
    $scope.submitted = true;

    if (!form.$valid) return;

    $scope.isSending = true;
    $scope.sendResult = null;

    const phone = $scope.phone;

    $http.post('/sms/appLink/', {
        phone: phone
      })
      .then(function success(response) {
          $scope.errorMsg = null;
          $scope.resetForm();

          $scope.sendResult = 'success';
          $scope.isSending = false;

          $scope.successMsg = response.message;

          tracking.trackEvent(SEGMENT_EVENTS.RequestedSMSDownloadLink, {
            phone: phone
          });
        },
        function error() {

          $scope.successMsg = null;
          $scope.errorMsg = 'Sorry unable to send SMS to number.';
          $scope.resetForm();

          $scope.sendResult = 'error';
          $scope.isSending = false;
        });
  };

  $scope.closeAlert = function() {
    $scope.errorMsg = null;
  };
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  'jsSdk.http',
  'trackingService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/smsDownloadLink/controller.js